
import { Component, Vue, Prop } from 'vue-property-decorator';
import BasicBadge from '@/components/BasicBadge.vue';
import FormatTime from '@/components/FormatTime.vue';
import TruncatedText from '@/components/TruncatedText.vue';
import { Conversation } from './type';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

@Component({
  components: { BasicBadge, FormatTime, TruncatedText },
  directives: { trackClick },
})
export default class ConversationList extends Vue {
  @Prop({ default: () => [] }) readonly conversations!: Conversation[];

  readonly BTN_EVTS = BTN_EVTS;
}
